import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'real-estate-developments-initial-register',
  storeModule.createStoreModule('real-estate-developments-initial-register')
)
